<script>
    export let width = '72';
    export let height = '72';
</script>

<svg {width} {height} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
        <circle cx="36" cy="36" r="32" fill="#F4FAFE" stroke="#F4FAFE" stroke-width="7.8" />
        <g>
            <path
                d="M21.871 48.7961C21.0868 49.0079 20.4236 48.1889 20.7938 47.4659L32.1911 25.2065L46.0136 42.2758L21.871 48.7961Z"
                fill="white"
                stroke="#0097FB"
                stroke-width="1.2"
            />
            <path
                d="M44.756 29.0829C46.936 31.5907 48.3969 34.2676 49.0144 36.5474C49.644 38.8718 49.3537 40.5729 48.3848 41.4152C47.4159 42.2574 45.6909 42.3082 43.4768 41.3612C41.3051 40.4324 38.8576 38.6131 36.6776 36.1053C34.4976 33.5975 33.0366 30.9206 32.4191 28.6408C31.7895 26.3164 32.0798 24.6153 33.0488 23.7731C34.0177 22.9308 35.7426 22.8801 37.9567 23.827C40.1284 24.7558 42.576 26.5751 44.756 29.0829Z"
                fill="white"
                stroke="#0097FB"
                stroke-width="1.2"
            />
            <path
                d="M31.8786 26.95C30.4678 34.5827 31.4272 40.6822 35.9854 44.8266"
                stroke="#0097FB"
                stroke-width="1.2"
            />
            <path
                d="M26.2564 36.8032C25.4505 40.8846 25.21 44.1299 29.2814 46.9371"
                stroke="#0097FB"
                stroke-width="1.2"
            />
            <path
                d="M41.7069 27.6386C43.5585 24.8044 45.6647 22.9416 43.6638 17.828"
                stroke="#0097FB"
                stroke-linecap="round"
            />
            <path
                d="M40.5476 34.7673C40.9407 34.4102 41.4825 33.9247 41.8122 33.6562C44.7489 31.2643 47.8233 30.0767 53.3801 31.3928"
                stroke="#0097FB"
                stroke-linecap="round"
            />
            <circle
                cx="50.5798"
                cy="24.7438"
                r="2"
                transform="rotate(-9 50.5798 24.7438)"
                stroke="#0097FB"
            />
            <circle
                cx="56.58"
                cy="35.1002"
                r="1.5"
                transform="rotate(-9 56.58 35.1002)"
                stroke="#0097FB"
                stroke-width="0.8"
            />
            <circle
                cx="37.58"
                cy="28.1002"
                r="1.5"
                transform="rotate(-9 37.58 28.1002)"
                stroke="#0097FB"
                stroke-width="0.8"
            />
            <path
                d="M38.4641 20.7491C38.5448 20.6404 38.6193 20.5251 38.6868 20.4035C39.5093 18.9196 38.9732 17.0498 37.4893 16.2273"
                stroke="#0097FB"
                stroke-linecap="round"
            />
            <path
                d="M52.314 37.9604C51.4872 36.9936 50.2141 36.4366 48.8534 36.5797C47.6762 36.7034 46.6722 37.3258 46.0293 38.215"
                stroke="#0097FB"
                stroke-linecap="round"
            />
        </g>
    </g>
</svg>
